import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromUser from '@core/state/user/user.reducers';


/**
 * Feature Selector
 **/
export const selectUserState = createFeatureSelector<fromUser.State>(fromUser.featureName);
export const selectClients = createSelector(selectUserState, state => state.clients);
export const selectDecorators = createSelector(selectUserState, state => state.decorators);

// Paginated search selectors
export const selectSearchedClients = createSelector(selectUserState, state => state.searchedClients);
export const selectSearchLoading = createSelector(selectUserState, state => state.searchLoading);
export const selectSearchTotal = createSelector(selectUserState, state => state.searchTotal);
export const selectSearchTotalAvailable = createSelector(selectUserState, state => state.searchTotalAvailable);
export const selectSearchPage = createSelector(selectUserState, state => state.searchPage);
export const selectSearchTotalPages = createSelector(selectUserState, state => state.searchTotalPages);